import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-night-900 text-cream-50 font-sans selection:bg-gold-400 selection:text-night-900" data-id="element-188">
      <Navigation data-id="element-189" />
      <main data-id="element-190">
        <HeroSection data-id="element-191" />
        <WelcomeSection data-id="element-192" />
        <OfferingsSection data-id="element-193" />
        <ReviewsSection data-id="element-194" />
        <AboutSection data-id="element-195" />
        <ContactSection data-id="element-196" />
      </main>
      <Footer data-id="element-197" />
    </div>;
}